import { SpearsApi } from './generated-src';
import { getAppSetting } from '../config/AppSettings';

export default function() {
  const apiBasePath = `${getAppSetting('apiUrl')}/jwt`;
  return new SpearsApi(undefined, apiBasePath);
}
